import { ImageWithCustomLoader } from '@components/image-with-custom-loader'
import { exhibitionTransition } from './header'
import { motion } from 'motion/react'
import { useSoloViewer } from '@components/solo-viewer/provider'

export const ExhibitionImageCurl = ({
  anchor,
  image1,
  image1AspectRatio,
  image2,
  image2AspectRatio,
  image3,
  content,
  align
}: {
  anchor?: string
  image1AspectRatio?: string
  image1: string
  image2: string
  image2AspectRatio?: string
  image3: string
  content: React.ReactElement
  align: 'left' | 'right'
}): React.ReactElement => {
  const { setSoloViewerImageData } = useSoloViewer()
  return (
    <div className="gap-sm grid w-full grid-cols-1 lg:grid-cols-2" id={anchor}>
      <motion.button
        className={`relative ${align === 'left' ? 'lg:order-last' : 'order-first'} w-full ${image1AspectRatio ? image1AspectRatio : 'aspect-square'}`}
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={exhibitionTransition}
        onClick={() => setSoloViewerImageData({ imageList: [image1, image2, image3], image: image1 })}
      >
        <ImageWithCustomLoader
          src={image1}
          alt="Artist big photo"
          style={{
            objectFit: 'cover'
          }}
          fill
          sizes="(max-width: 1080px) 100vw, 50vw"
        />
      </motion.button>
      <div>
        <div className="gap-x-sm grid w-full grid-cols-2">
          <motion.button
            className={`${align === 'left' ? 'order-last' : 'order-first'} relative ${image2AspectRatio ? image2AspectRatio : 'aspect-square'} w-full`}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={exhibitionTransition}
            onClick={() => setSoloViewerImageData({ imageList: [image1, image2, image3], image: image2 })}
          >
            <ImageWithCustomLoader
              src={image2}
              alt="Release small photo"
              style={{
                objectFit: 'cover'
              }}
              fill
              sizes="(max-width: 1080px) 50vw, 33vw"
            />
          </motion.button>
          <motion.button
            className={`relative aspect-[2/3] w-full`}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={exhibitionTransition}
            onClick={() => setSoloViewerImageData({ imageList: [image1, image2, image3], image: image3 })}
          >
            <ImageWithCustomLoader
              src={image3}
              alt="Release medium picture"
              style={{
                objectFit: 'cover'
              }}
              fill
              sizes="(max-width: 1080px) 50vw, 33vw"
            />
          </motion.button>
        </div>
        <motion.div
          className="gap-y-md lg:px-2xl px-md pt-2xl flex flex-col"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={exhibitionTransition}
        >
          {content}
        </motion.div>
      </div>
    </div>
  )
}
